"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "feilmeldingerForFelt", {
    enumerable: true,
    get: function() {
        return feilmeldingerForFelt;
    }
});
var _sjekker = require("../felt/sjekker");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var feilmeldingerForFelt = function(valideringsregler) {
    return function() {
        var regelFilter = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
            return true;
        };
        return function(felt, verdi, valideringsstate, kortData, visningsdata) {
            if (felt.disabled) {
                return [];
            }
            return (felt.valideringer || []).map(function(validering) {
                var _valideringsstate_overrideRuleMapping, _valideringsstate;
                if (typeof validering === "object") {
                    var _valideringsstate_overrideRuleMapping1, _valideringsstate1;
                    var valideringNavn = ((_valideringsstate1 = valideringsstate) === null || _valideringsstate1 === void 0 ? void 0 : (_valideringsstate_overrideRuleMapping1 = _valideringsstate1.overrideRuleMapping) === null || _valideringsstate_overrideRuleMapping1 === void 0 ? void 0 : _valideringsstate_overrideRuleMapping1[validering.navn]) || validering.navn;
                    return _object_spread_props(_object_spread({}, validering), {
                        valideringsregel: valideringsregler[valideringNavn]
                    });
                }
                var valideringNavn1 = ((_valideringsstate = valideringsstate) === null || _valideringsstate === void 0 ? void 0 : (_valideringsstate_overrideRuleMapping = _valideringsstate.overrideRuleMapping) === null || _valideringsstate_overrideRuleMapping === void 0 ? void 0 : _valideringsstate_overrideRuleMapping[validering]) || validering;
                return {
                    navn: valideringNavn1,
                    valideringsregel: valideringsregler[valideringNavn1]
                };
            }).filter(function(validering) {
                return regelFilter(validering.valideringsregel);
            }).filter(function(validering) {
                var args = validering.args || {};
                return !valideringsstate || !valideringsstate.beregning || !args.ignorerVedBeregning;
            }).filter(function(validering) {
                var betingelse = validering.betingelse;
                return !betingelse || (0, _sjekker.foelgerBetingelse)(kortData, betingelse);
            }).filter(function(validering) {
                return !validering.valideringsregel.valider(verdi, valideringsstate, felt, kortData, visningsdata, validering.args);
            }).map(function(validering) {
                var args = validering.args || {};
                return {
                    feilmelding: validering.valideringsregel.feilmelding,
                    args: args
                };
            });
        };
    };
};
